// ----------------------------------------------------------------------

export const themeConfig = {
  /** **************************************
   * Base
   *************************************** */
  direction: 'ltr',
  defaultMode: 'light',
  modeStorageKey: 'theme-mode',
  classesPrefix: 'minimal',
  /** **************************************
   * Typography
   *************************************** */
  fontFamily: {
    // primary: 'Public Sans Variable',
    primary: 'Pretendard Variable',
    secondary: 'Pretendard Variable',
  },
  /** **************************************
   * Palette
   *************************************** */
  palette: {
    primary: {
      lighter: '#E7F7FC',
      light: '#9FDFF6',
      main: '#10AFEA',
      dark: '#007BB8',
      darker: '#005782',
      contrastText: '#FFFFFF'
    },
    secondary: {
      lighter: '#E5FAF1',
      light: '#9AEDC9',
      main: '#03D278',
      dark: '#009C58',
      darker: '#007140',
      contrastText: '#FFFFFF'
    },
    info: {
      lighter: '#CAFDF5',
      light: '#61F3F3',
      main: '#00B8D9',
      dark: '#006C9C',
      darker: '#003768',
      contrastText: '#FFFFFF',
    },
    success: {
      lighter: '#D3FCD2',
      light: '#77ED8B',
      main: '#22C55E',
      dark: '#118D57',
      darker: '#065E49',
      contrastText: '#ffffff',
    },
    warning: {
      lighter: '#FFF5CC',
      light: '#FFD666',
      main: '#FFAB00',
      dark: '#B76E00',
      darker: '#7A4100',
      contrastText: '#1C252E',
    },
    error: {
      lighter: '#FFE9D5',
      light: '#FFAC82',
      main: '#FF5630',
      dark: '#B71D18',
      darker: '#7A0916',
      contrastText: '#FFFFFF',
    },
    pink: {
      lighter: '#FFEFF5',
      light: '#FFBFD7',
      main: '#FF619C',
      dark: '#EC2872',
      darker: '#CA0C54',
      contrastText: '#FFFFFF'
    },
    yellow: {
      lighter: '#FFF9EB',
      light: '#FFEAB1',
      main: '#FFCB3D',
      dark: '#D99F00',
      darker: '#B58500',
      contrastText: '#FFFFFF'
    },
    marine: {
      lighter: '#E5FBFB',
      light: '#99F0F0',
      main: '#00DBDB',
      dark: '#00B7B7',
      darker: '#008888',
      contrastText: '#FFFFFF'
    },
    violet: {
      lighter: '#EEF0FE',
      light: '#BEC6FE',
      main: '#5D72FD',
      dark: '#3E53DF',
      darker: '#2439C2',
      contrastText: '#FFFFFF'
    },
    orange: {
      lighter: '#FFF2E9',
      light: '#FFCCA8',
      main: '#FF8126',
      dark: '#E7680D',
      darker: '#CE5600',
      contrastText: '#FFFFFF'
    },
    purple: {
      lighter: '#F9EEFF',
      light: '#E9BCFF',
      main: '#C859FF',
      dark: '#9626CD',
      darker: '#7A11AE',
      contrastText: '#FFFFFF'
    },
    /** **************************************
     * 700~900은 기존 컬로로 매칭
     *************************************** */
    grey: {
    // ⚠️ 키를 따옴표로 두는 이유: minimal-shared ChannelPalette 의 `${string & K}Channel` 이
    //    숫자 키를 never 로 떨궈 `500Channel` 타입이 증발한다. 런타임은 동일하다.
      '50': '#FBFBFB',
      '100': '#F8F8F8',
      '200': '#F4F4F5',
      '300': '#E9E9EA',
      '400': '#D2D2D2',
      '500': '#A7A7A7',
      '600': '#929292',
      '700': '#454F5B',
      '800': '#1C252E',
      '900': '#141A21',
    },
    bluegrey: {
      "50": '#EFF2F4',
      "100": '#E6EBEE',
      "200": '#E3E5E8'
    },
    common: {
      black: '#222222',
      white: '#FFFFFF'
    },
  },
  /** **************************************
   * Css variables
   *************************************** */
  cssVariables: {
    cssVarPrefix: '',
    colorSchemeSelector: 'data-color-scheme',
  },
};

